import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-wrap text-sm align-items-baseline justify-content-end" }
const _hoisted_2 = { class: "inline-flex caption align-items-center gutter-x-s1" }
const _hoisted_3 = { key: 1 }

import TooltipIcon from '@/components/tooltip/TooltipIcon.vue';
import Icon from '@/components/icon/Icon.vue';
import { computed, useSlots } from 'vue';
import BigNumber from 'bignumber.js';
import { printBalanceWithCurrency, printUSDBalanceWithCurrency } from '@/utils/format';
import { useI18n } from 'vue-i18n';
import { USD_TOKEN } from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/common/constants/USD_TOKEN';
import LpAmountFormat from '@/components/LpAmountFormat.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputBalance',
  props: {
    balanceValue: null,
    balanceSymbol: null,
    caption: null,
    tooltip: null,
    isBalanceError: { type: Boolean },
    isMaxDisabled: { type: Boolean },
    notMaxButton: { type: Boolean },
    notErrorIcon: { type: Boolean },
    lpBalance: { type: Boolean }
  },
  emits: ["setMax"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'setMax'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  balanceValue: BigNumber.Value;
  balanceSymbol?: string;
  caption?: string;
  tooltip?: string;
  isBalanceError: boolean;
  isMaxDisabled?: boolean;
  notMaxButton?: boolean;
  notErrorIcon?: boolean;
  lpBalance?: boolean;
}




const { t } = useI18n();
const slots = useSlots();
const isUSDValue = computed(() => props.balanceSymbol === USD_TOKEN.symbol);
const balance = computed(() => BigNumber(props.balanceValue));
const isNotBalance = computed(() => balance.value.eq(0));

const balanceToView = computed(() => {
  if (isUSDValue.value) {
    return printUSDBalanceWithCurrency(balance.value, props.balanceSymbol ?? '');
  }

  return printBalanceWithCurrency(balance.value, props.balanceSymbol ?? '');
});
const captionToView = computed(() =>
  props.lpBalance ? t('lpTokens') : props.caption ?? t('balance'),
);

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isBalanceError && !__props.notErrorIcon)
      ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          class: "text-danger mr-s1 align-self-center",
          name: "danger",
          size: "16"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass({ 'text-danger': __props.isBalanceError })
      }, _toDisplayString(_unref(captionToView)), 3),
      (__props.tooltip || _unref(slots).tooltip)
        ? (_openBlock(), _createBlock(TooltipIcon, {
            key: 0,
            color: __props.isBalanceError ? 'danger' : '',
            "no-space": ""
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "tooltip", {}, () => [
                _createTextVNode(_toDisplayString(__props.tooltip), 1)
              ])
            ]),
            _: 3
          }, 8, ["color"]))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(`ml-s0 ${__props.isBalanceError ? 'text-danger' : ''}`)
          }, ":", 2)),
      (!_unref(balance))
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 2,
            class: "ml-s1"
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (__props.lpBalance)
              ? (_openBlock(), _createBlock(LpAmountFormat, {
                  key: 0,
                  "lp-amount": __props.balanceValue,
                  "is-short": ""
                }, null, 8, ["lp-amount"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(balanceToView)), 1))
          ], 64))
    ]),
    (!__props.notMaxButton)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          disabled: __props.isMaxDisabled || _unref(isNotBalance),
          class: "ml-2 button-max",
          label: "Max",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('setMax')))
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})